// Запись на мероприятие
function ajaxPreEntryEvent(jqForm) {
	var dataToSend = 'kind=event&';

	trimFormFields(jqForm);
	dataToSend += jqForm.serialize();

	// console.log(dataToSend);

	$.ajax({
		data: dataToSend,
		url: '/pre-entry/',
		method: "POST",

		success: function(response) {
			var responseObj = JSON.parse(response);

			// console.log(responseObj);

			if (responseObj.status == true) {
				var labels = jqForm.find('label.label-radio');

				hidePopUps();
				showNotification(responseObj.result.message, 'success');

				labels.filter('.active').removeClass('active').addClass('with-status').find('input[type="radio"]').removeAttr('checked').parent().find('.status').eq(0).removeClass('invisible');

				if (labels.not('.with-status').length > 0) labels.not('.with-status').eq(0).trigger('click');
				else {
					if (labels.length == 1) $('.payment-unavailable-container.pre-entry.one').removeClass('invisible');
					else if (labels.length > 1) $('.payment-unavailable-container.pre-entry.several').removeClass('invisible');

					$('.pre-entry-button').empty().remove();
					$('.body-cover-pop-up-wrapper.pre-entry-event').empty().remove();
				}
			}
			else {
				if (responseObj.error.message) showNotification(responseObj.error.message, 'error');
			}
		}
	});
}